module.exports = __webpack_public_path__ + "static/indycode2019keynote-a5da100f23b5283ef2a05974819ce38f.jpg";